import React from "react";
/* eslint-disable */
import {
  Box,TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.priceNegotiation;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;
    return (
      <div align='left' style={{ padding: '15px' }}>
        <h3><center><u>Category Wise Quantity Bought against Purchase Order Report</u></center></h3>
        <div >&nbsp;</div>
        <div>&nbsp;</div>
        <Box minWidth={1200}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>SKU Category</TableCell>
                  <TableCell align={'right'}>Ordered Qty</TableCell>
                  <TableCell align={'right'}>Supplied Qty</TableCell>
                  <TableCell align={'right'}>Fill Rate</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.productSubCategoryName}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.orderedQty == 0 ? "-" : parseFloat(row.orderedQty).toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.suppliedQty == 0 ? "-" : parseFloat(row.suppliedQty).toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.fillRate == 0 ? "-" : parseFloat(row.fillRate).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} >Total</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalOrderedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalSuppliedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalFillRate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
